
import { useParams } from 'react-router-dom';
import { ListasCabFormState } from '../../../context/listascab/ListasCabFormState';
import { Form } from './form';

export const ListasCabFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Lista de Precios":"Crear Lista de Precios";

  return (
    <ListasCabFormState>
         <br />
        <Form title={title} />
    </ListasCabFormState>
  );
};
